import { getAllProducts } from "../data/products";
import Cookies from "js-cookie";

export const calculateDiscount = (actualPrice, sellingPrice) => {
  if (!actualPrice || !sellingPrice) return 0;
  const discount = ((actualPrice - sellingPrice) / actualPrice) * 100;
  return Math.round(discount);
};

export const getRandomProducts = (excludeId = null) => {
  const allProducts = getAllProducts();
  const filteredProducts = excludeId
    ? allProducts.filter((product) => product.id !== excludeId)
    : allProducts;

  const shuffled = [...filteredProducts].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, 5);
};

export const addToRecentlyViewed = (productId) => {
  const recentlyViewed = Cookies.get("recentlyViewed");
  let products = recentlyViewed ? JSON.parse(recentlyViewed) : [];

  products = products.filter((id) => id !== productId);
  products.unshift(productId);

  products = products.slice(0, 6);

  Cookies.set("recentlyViewed", JSON.stringify(products), { expires: 7 });
};

export const getRecentlyViewedProducts = (currentProductId) => {
  const recentlyViewed = Cookies.get("recentlyViewed");
  if (!recentlyViewed) return [];

  const productIds = JSON.parse(recentlyViewed);
  const allProducts = getAllProducts();

  return productIds
    .map((id) => allProducts.find((product) => product.id === parseInt(id)))
    .filter((product) => product && product.id !== currentProductId)
    .slice(0, 5);
};

export const transformProductData = (data) => ({
  id: data._id || data.id,
  name: data.productName,
  price: `$${Number(data.sellingPrice).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`,
  images: data.images && data.images.length > 0
    ? data.images
    : [data.categoryId?.categotyImage],
  type: data.categoryName,
  discount: calculateDiscount(data.actualPrice, data.sellingPrice),
  _id: data._id,
});

export const formatPrice = (price) => {
  return Number(price).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
